export default "__VITE_ASSET__CcwRpsKY__"